import { InjectionToken } from '@angular/core';

export const STRIPE_PUBLISHABLE_KEY_BV = new InjectionToken<string>('Stripe Publishable Key');
export const STRIPE_PUBLISHABLE_KEY_GMBH = new InjectionToken<string>(
  'Stripe Publishable Key Gmbh',
);
export const STRIPE_PUBLISHABLE_KEY_INC = new InjectionToken<string>('Stripe Publishable Key Inc');
export const STRIPE_PUBLISHABLE_KEY_SAS = new InjectionToken<string>('Stripe Publishable Key Sas');
export const STRIPE_OPTIONS = new InjectionToken<any>('Stripe Options');
